import React from 'react';
import { Col, Row } from '@thd-olt-component-react/grid';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { KPFBlock } from './KPFBlock';
import '../../styles/results-wrapped.scss';

let portraitIndex = 0;
let landscapeIndex = 0;
let filterIndex = 0;

const ShoppableKPF = ({ itemIndex = 0, features = [], dimensions = [] }) => {
  const calculatedIndex = itemIndex + 1;
  const showKPFPortrait = (calculatedIndex === 6 || (calculatedIndex > 13 && (calculatedIndex - 6) % 8 === 0));
  const showKPFLandscape = (calculatedIndex === 9 || (calculatedIndex > 20 && (calculatedIndex - 9) % 12 === 0));

  if (itemIndex === 0) {
    portraitIndex = 0;
    landscapeIndex = 0;
    filterIndex = 0;
  }

  const showKPF = showKPFPortrait || showKPFLandscape;
  if (!showKPF) return null;

  const kpfClasses = classNames({ 'KPF-wrapper--portrait': showKPFPortrait },
    { 'KPF-wrapper--landscape': !showKPFPortrait },
    'KPF-wrapper'
  );

  if (showKPFLandscape) {
    filterIndex = landscapeIndex;
    landscapeIndex += 1;
  } else if (showKPFPortrait) {
    filterIndex = portraitIndex;
    portraitIndex += 1;
  }

  return (
    <Col fallback="12" className={kpfClasses}>
      <KPFBlock
        featureIndex={filterIndex}
        features={features}
        dimensions={dimensions}
      />
    </Col>
  );
};

ShoppableKPF.displayName = 'ShoppableKPF';

export {
  ShoppableKPF
};

ShoppableKPF.propTypes = {
  itemIndex: PropTypes.number.isRequired,
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      refinements: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      refinementId: PropTypes.string.isRequired,
      refinementUrl: PropTypes.string.isRequired
    })
  ).isRequired
};
